import {CheckCircleIcon, XCircleIcon} from '@heroicons/react/24/outline';
import {TrashIcon} from '@heroicons/react/24/solid';
import {Dialog, DialogContent, DialogFooter, DialogHeader} from '@/shadcn_components/ui/dialog';
import {FileInput, RenderPreviewOptions} from '@/components/refinedev/FileInput';
import {DialogStateProps} from 'hooks/useDialogState';
import {useEffect, useState} from 'react';
import {apiClient} from '@/lib/client';
import {ImageItemView} from './components';
import {Button} from '@/shadcn_components/ui/button';
import Spinner from '@/components/basic/Spinner';
import {FormProvider, useForm} from 'react-hook-form';

type UploadStatus = 'wait' | 'uploading' | 'completed' | 'error';

const MediaCreatePopup = (props: Pick<DialogStateProps, 'open' | 'closeDialog'>) => {
  const [uploadStatus, setUploadStatus] = useState<UploadStatus[]>([]);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<any>(undefined);
  // const refresh = useRefresh();
  const useFormResults = useForm({
    defaultValues: {test_files: []},
  });
  const {handleSubmit} = useFormResults;

  async function onSubmit(data) {
    console.log('submit', data);
    const {test_files} = data;
    // const us = test_files.map(v => 'wait');
    // setUploadStatus(us);
    let fileIndex = 0;
    try {
      // set status flags
      setUploading(true);
      setError(undefined);

      // loop
      for (fileIndex = 0; fileIndex < test_files.length; fileIndex++) {
        if (uploadStatus[fileIndex] === 'completed') continue;
        const f = test_files[fileIndex];
        setUploadStatus(
          test_files.map((v, j) => {
            if (j < fileIndex) return 'completed';
            if (j === fileIndex) return 'uploading';
            return 'wait';
          }),
        );

        const formdata = new FormData();
        formdata.append('file', f.rawFile);

        await apiClient.post('/api/upload/image', formdata, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          withCredentials: true,
        });
        // await sleep(2000); //simulate upload
        // if (fileIndex == 1) throw 'Test error';//test error
      }
      // all complete
      setUploadStatus(test_files.map(v => 'completed'));
      props.closeDialog();
      // refresh();
    } catch (err) {
      console.error('Upload error');
      setError(err);
      setUploadStatus(
        test_files.map((v, j) => {
          if (j < fileIndex) return 'completed';
          if (j === fileIndex) return 'error';
          return 'wait';
        }),
      );
    } finally {
      setUploading(false);
    }
  }

  /// when open, reset uploading status
  useEffect(() => {
    if (props.open) setUploadStatus([]); //open clear status
  }, [props.open]);

  return (
    <Dialog open={props.open} onOpenChange={props.closeDialog}>
      <DialogContent className="overflow-y-auto max-h-[70vh]">
        <FormProvider {...useFormResults}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <DialogHeader>Tải ảnh lên</DialogHeader>

            <FileInput
              source="test_files"
              label=""
              multiple={true}
              renderPreview={(files, options) => renderPreview(files, uploadStatus, options)}
              dropzonePrompt={
                <>
                  {/* <PhotoIcon className="w-8 h-8" /> */}
                  <h3 className="mt-2 text-sm font-medium text-gray-900">
                    Kéo thả vào đây hoặc nhấn để chọn file tải lên
                  </h3>
                  <p className="mt-1 text-xs text-gray-500">PNG, JPG tới 10MB</p>
                </>
              }
            />

            {!uploading ? (
              <DialogFooter>
                <div className="grow text-red-500">{error?.message || JSON.stringify(error)}</div>
                <Button
                  variant="ghost"
                  color="red"
                  onClick={e => {
                    e.stopPropagation();
                    props.closeDialog();
                  }}
                  className="mr-1">
                  <span>Hủy bỏ</span>
                </Button>
                <Button type="submit">
                  <span>Tải lên</span>
                </Button>
              </DialogFooter>
            ) : (
              <DialogFooter>
                <Spinner className="w-12 h-12" />
              </DialogFooter>
            )}
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
};

function renderPreview(files: any[], uploadStatus: UploadStatus[], options?: RenderPreviewOptions) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
      {files.map((f, i) => (
        <ImageItemView
          key={i}
          src={f.src}
          alt={f.filename}
          // checkable={false}
          header={<p className="bg-gray-100">{f.title}</p>}
          overlay={
            uploadStatus &&
            uploadStatus.length === files.length &&
            ({
              uploading: <Spinner className="w-2/3 h-2/3" />,
              completed: <CheckCircleIcon className="w-2/3 h-2/3 text-green-500" />,
              error: <XCircleIcon className="w-2/3 h-2/3 text-red-500" />,
              // wait: <></>,
            }[uploadStatus[i]] ||
              null)
          }
          footer={
            <Button
              variant="ghost"
              size="sm"
              className="px-1 py-1 rounded-md"
              onClick={() => {
                console.log('click remove', f);
                options?.removeFile?.(f);
              }}>
              <TrashIcon className="w-4 h-4" />
            </Button>
          }
        />
      ))}
    </div>
  );
}

export default MediaCreatePopup;
